/**
 * Staff Filter Select Component
 * Used by owners to filter records by staff member
 */
import React from 'react';
import { Users } from 'lucide-react';

const StaffFilterSelect = ({ 
  staffList, 
  selectedStaffId, 
  onChange, 
  className = '' 
}) => {
  if (!staffList || staffList.length === 0) return null;
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Users className="w-4 h-4 text-slate-400" />
      <select
        value={selectedStaffId || ''}
        onChange={(e) => onChange(e.target.value || null)}
        className="text-[13px] border border-slate-200 rounded-md px-2 py-1.5 bg-white text-slate-700 focus:outline-none focus:ring-1 focus:ring-teal-500 focus:border-teal-500"
        data-testid="staff-filter-select"
      >
        <option value="">All Staff</option>
        {staffList.map((staff) => (
          <option key={staff.id} value={staff.id}>
            {staff.name || staff.mobile || staff.email || 'Unknown'}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StaffFilterSelect;
